module.exports = __webpack_public_path__ + "static/media/brush_1.04bc1081.png";